import { CommonValuableConceptResponse, ValuableType } from '@/api/resources/common/valuable-concepts/valuable-concept.dto'
import axios from 'axios'

class CommonValuableConceptsService {
    async getAllActiveValuableByLaboratory(laboratoryId: number, valuableType: ValuableType): Promise<CommonValuableConceptResponse> {
        const response = await axios.get<CommonValuableConceptResponse>(`/laboratories/${laboratoryId}/allValuableConcepts`, { params: { valuableType } })
        return response.data
    }
}

export const commonValuableConceptsService = new CommonValuableConceptsService()
